module.exports = __webpack_public_path__ + "img/bingo_ball-70.99a74703.png";